"use client";
import React, { useState } from "react";
import AnnouncementCard from "./AnnouncementCard";
import { GroupHeader } from "../../../ui/Headers";
import Button from "../../../ui/Button";
import Pagination from "./Pagination";
import { Announcement } from "src/types";
import { useCarouselAnnouncements } from "src/app/lib/useCarouselAnnouncement";

const AnnouncementSection: React.FC<{
  header?: React.ReactNode;
  arr?: Announcement[];
  className?: string;
  secondary?: boolean;
}> = ({ header, arr, secondary, className }) => {
  const {
    emblaRef,
    canScrollPrev,
    canScrollNext,
    scrollSnaps,
    emblaApi,
    selectedIndex,
    onDotButtonClick,
    announcements,
  } = useCarouselAnnouncements();

  const dataToMap = secondary ? arr : announcements;
  if (dataToMap?.length === 0) return null;
  return (
    <section className={`py-5 pb-14 `}>
      <div className="mx-auto">
        <div className="wrapper">
          {!header && (
            <GroupHeader
              max={1000}
              subheader="Keep yourself updated, motivated, and one step ahead with our in-depth guides and expert tips designed specifically for your property journey."
              header="Announcement"
            />
          )}
        </div>

        {header && header}
        <div className={`relative ${!className && "wrapper"}  `}>
          <button
            className={`absolute rotate-180  top-[25%] z-10 ${
              canScrollPrev ? "visible" : "invisible"
            }`}
            onClick={() => emblaApi && emblaApi.scrollPrev()}
          >
            <ButtonControls />
          </button>
          <div className={`w-full `}>
            <div className="embla overflow-hidden" ref={emblaRef}>
              <div className="embla__container items-stretch flex gap-5">
                {dataToMap?.map((announcement, index) => (
                  <div
                    className="embla__slide w-auto select-none shrink-0"
                    key={index}
                  >
                    <AnnouncementCard {...announcement} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="pag mt-3 flex justify-center">
            <Pagination
              onDotButtonClick={onDotButtonClick}
              selectedIndex={selectedIndex}
              scrollSnaps={scrollSnaps}
            />
          </div>

          {/* Custom Next Button */}
          <button
            className={`absolute top-[25%] right-4 transform  z-10  ${
              canScrollNext ? "visible" : "invisible"
            }`}
            onClick={() => emblaApi && emblaApi.scrollNext()}
          >
            <ButtonControls />
          </button>
        </div>

        <Button
          href="/announcements"
          className="w-max mx-auto primary-btn px-8 py-3 block mt-12"
        >
          Explore More
        </Button>
      </div>
    </section>
  );
};
export default AnnouncementSection;

export const ButtonControls = () => {
  const [hovered, setHovered] = useState(false);
  const bgColor = hovered ? "var(--primary-color)" : "white";
  const color = hovered ? "white" : "var(--primary-color)";
  return (
    <svg
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      className="transition-colors duration-500"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1580_62305)">
        <circle
          cx="24"
          cy="24"
          r="24"
          transform="matrix(-1 0 0 1 58 8)"
          fill={bgColor}
        />
        <path
          d="M28.7344 22.0235C28.6262 21.909 28.5416 21.7743 28.4855 21.6271C28.4293 21.4799 28.4027 21.3231 28.4072 21.1657C28.4116 21.0082 28.447 20.8532 28.5114 20.7094C28.5758 20.5656 28.6679 20.4359 28.7824 20.3277C28.8969 20.2195 29.0315 20.1349 29.1787 20.0788C29.3259 20.0226 29.4827 19.996 29.6402 20.0005C29.7977 20.0049 29.9527 20.0404 30.0965 20.1047C30.2403 20.1691 30.37 20.2612 30.4782 20.3757L40.6722 31.1693C40.8827 31.392 41 31.6868 41 31.9933C41 32.2997 40.8827 32.5945 40.6722 32.8172L30.4782 43.612C30.3707 43.729 30.241 43.8235 30.0967 43.89C29.9524 43.9565 29.7963 43.9936 29.6375 43.9992C29.4788 44.0049 29.3204 43.9789 29.1718 43.9229C29.0231 43.8668 28.8871 43.7818 28.7716 43.6727C28.6561 43.5636 28.5634 43.4326 28.4989 43.2874C28.4344 43.1422 28.3994 42.9857 28.396 42.8268C28.3925 42.668 28.4206 42.51 28.4787 42.3621C28.5368 42.2143 28.6237 42.0794 28.7344 41.9654L38.1513 31.9933L28.7344 22.0235Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1580_62305"
          x="0"
          y="0"
          width="68"
          height="68"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1580_62305"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1580_62305"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
